import AccessCodeGate from '../components/AccessCodeGate';

function AccessEbook() {
  return (
    <AccessCodeGate
      type="EBOOK"
      title="EBOOK"
      imageSrc="/images/new_images/11.png"
      buttonLabel="ACCESS EBOOK"
    />
  );
}

export default AccessEbook;
